import { combineReducers } from 'redux';
import { authConstants } from '../constants';
import registerReducer from './register';
import authReducer from './auth';
import userReducer from './user';
import messagesReducer from './messages';
import createEventReducer from './createEvent';
import eventsReducer from './events';
import framesReducer from './frames';
import imagesReducer from './images';
import printReducer from './print';
import leadsReducer from './leads';
import coverReducer from './cover';

const appRreducer = combineReducers({
    registerReducer,
    authReducer,
    userReducer,
    messagesReducer,
    createEventReducer,
    eventsReducer,
    framesReducer,
    imagesReducer,
    printReducer,
    leadsReducer,
    coverReducer
});

/**
 * for reset all state data after success logout
 */
const rootReducer = (state = {}, action) => {
    if (action.type === authConstants.LOGOUT_SUCCESS) {
        state = undefined;
    }
  
    return appRreducer(state, action);
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js